import React, { useContext, useEffect, useState } from "react";
import { action, API, controller } from "../../../../api/api";
import PayBalanceForm from "../PayBalance/PayBalanceForm";
import { Alert, Dialog } from "../../../../layout";
import { useFormatPrice } from "hooks";
import { AppContext } from "App";

const AccountsWidget = ({ supplier, setReloadKey }) => {
  const { access } = useContext(AppContext);
  const formatPrice = useFormatPrice();
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });
  const [accounts, setAccounts] = useState({
    balance: 10000,
    totalPurchase: 256900,
  });

  useEffect(() => {
    if (supplier && supplier.id) fetchAccounts();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [supplier]);

  const fetchAccounts = () => {
    setLoading(true);
    API(controller.SupplierTxn + action.GetAccountsBySupplier).getById(
      supplier.id,
      (res) => {
        setLoading(false);
        res && res.status === 200
          ? setAccounts({ ...res.result })
          : console.error("Error: ", res);
      }
    );
  };

  const handlePayBalance = () => {
    access?.supplier?.paymentReceive &&
      accounts.balance > 0 &&
      setShowForm(true);
  };

  const renderWidget = (label, value, className, onClick) => (
    <div
      onClick={onClick}
      className={`flex flex-col p-[10px] rounded-[15px] shadow-sm cursor-pointer hover:shadow-md w-fit min-w-[130px] font-bold ${className}`}
    >
      <span className="font-bold text-[11px] uppercase tracking-wider">
        {label}:
      </span>
      <span className="text-[18px]">{formatPrice(value)}</span>
    </div>
  );

  return loading ? (
    "Loading..."
  ) : (
    <>
      <div className="flex flex-wrap gap-3 justify-between">
        <div>
          <span className="text-gray-500 uppercase font-bold border-left tracking-wider w-full text-[18px] min-w-[70px]">
            Transactions
          </span>
        </div>
        <div className="flex flex-wrap gap-4">
          {renderWidget(
            "Total Spend",
            accounts.totalSpend,
            "border text-gray-500 !shadow-none"
          )}
          {accounts.balance > 0
            ? renderWidget(
                "Pay Balance",
                accounts.balance,
                "bg-red-100 text-red-500",
                () => handlePayBalance()
              )
            : accounts.balance < 0 &&
              renderWidget(
                "Credit Balance",
                Math.abs(accounts.balance),
                "bg-green-50 text-green-500",
                () => handlePayBalance()
              )}
        </div>
      </div>

      {/* Payblanace Form */}
      {showForm && (
        <Dialog show={showForm} onClose={false} maxWidth="sm">
          <PayBalanceForm
            {...{
              setShowForm,
              setAlert,
              supplierId: supplier.id,
              balance: accounts.balance,
              fetchAccounts,
              setReloadKey,
            }}
          />
        </Dialog>
      )}

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default AccountsWidget;
